import {
  LegacyCard,
  Page,
  TextField,
  Layout,
  FormLayout,
  Form,
  FooterHelp,
  TextContainer,
  SkeletonPage,
  SkeletonBodyText,
  Select,
  Checkbox,
} from '@shopify/polaris';
import { useState, useEffect, useContext } from 'react';

import { deleteUser, editUserId, getUserId } from '../../../services/userService.js';
import { useHistory, useParams } from 'react-router-dom';
import ToastContext from '../../../context/ToastContext';
import { SET_OK, SET_ERROR } from '../../../context/ToastReducer';
import { listRoles } from '../../../services/rolesService.js';
import { listDeposits } from '../../../services/depositsService.js';
import { Multiselector } from '../../UI/Deposits/MultiSelector.jsx';

const EditUser = () => {
  const { id } = useParams();
  const history = useHistory();
  const [, dispatchToast] = useContext(ToastContext);

  const handleDeleteUser = (id) =>
    window.confirm('¿Estás seguro de que quieres eliminar este usuario?') &&
    deleteUser(id)
      .then((r) => {
        dispatchToast({ type: SET_OK, payload: r.data });
        history.push(returnUrl);
      })
      .catch((e) => {
        dispatchToast({ type: SET_ERROR, payload: e.response.data });
      });

  const returnMatch = window.location.search.match(/\??r=(.+)&?/);
  const returnUrl = returnMatch && returnMatch.length > 1 ? window.atob(returnMatch[1]) : '/users';

  const defaultEdit = {
    name: '',
    surname: '',
    phone: '',
    email: '',
    password: '',
    admin: false,
    canViewSells: true,
  };

  const [user, setUser] = useState(null);
  const [edit, setEdit] = useState(defaultEdit);
  const [roles, setRoles] = useState([]);
  const [operationDeposits, setOperationDeposits] = useState([]);
  const [transferDeposits, setTransferDeposits] = useState([]);
  const [pwconfirm, setPwconfirm] = useState(false);
  const [pwconfirmValue, setPwconfirmValue] = useState('');

  useEffect(() => {
    Promise.all([getUserId(id), listRoles(), listDeposits()]).then(([u, r, d]) => {
      setUser({ ...u.data, role: u.data.role.slug });
      setEdit({ ...u.data, role: u.data.role.slug });
      setRoles(r.data.roles);
      setOperationDeposits(d.data.data);
      setTransferDeposits(d.data.data);
    });
    // eslint-disable-next-line
  }, []);

  const handleSubmit = () => {
    // e.preventDefault();

    editUserId(id, edit)
      .then((r) => {
        dispatchToast({ type: SET_OK, payload: { message: 'Datos cambiados' } });
        history.push(returnUrl);
      })
      .catch((e) => {
        dispatchToast({ type: SET_ERROR, payload: e.response.data });
      });
  };

  const handleChangeDeposits = (selected, type) => {
    setEdit({ ...edit, [type]: selected.map((d) => ({ id: d })) });
  };

  return (
    <>
      {!user && (
        <SkeletonPage primaryAction>
          {/* <Divider></Divider> */}

          <Layout>
            <Layout.AnnotatedSection
              id="editUser"
              title="Editar usuario"
              description={
                <>
                  <strong>Nota:</strong> Si no se cambia la contraseña, se mantendrá la actual
                </>
              }
            >
              <LegacyCard>
                <LegacyCard.Section>
                  <TextContainer>
                    <SkeletonBodyText />
                  </TextContainer>
                </LegacyCard.Section>
                <LegacyCard.Section>
                  <TextContainer>
                    <SkeletonBodyText />
                  </TextContainer>
                </LegacyCard.Section>
              </LegacyCard>
            </Layout.AnnotatedSection>
            <Layout.AnnotatedSection
              id="editUser"
              title="Modificar contraseña"
              description="Introduzca la nueva contraseña dos veces para confirmarla"
            >
              <LegacyCard sectioned>
                <TextContainer>
                  <SkeletonBodyText />
                </TextContainer>
              </LegacyCard>
            </Layout.AnnotatedSection>
          </Layout>
        </SkeletonPage>
      )}

      {user && (
        <>
          <Page
            title={user.name}
            subtitle={user.email}
            backAction={{ content: 'list users', url: returnUrl }}
            primaryAction={{
              content: 'Borrar usuario',
              destructive: true,
              onAction: () => handleDeleteUser(id),
            }}
            divider
          >
            <Layout>
              <Layout.AnnotatedSection
                id="editUser"
                title="Editar usuario"
                description={
                  <>
                    <strong>Nota:</strong> Si no se cambia la contraseña, se mantendrá la actual
                  </>
                }
              >
                <LegacyCard
                  primaryFooterAction={{
                    content: 'GUARDAR CAMBIOS',
                    onClick: (e) => handleSubmit(),
                  }}
                >
                  <LegacyCard.Section>
                    <Form onSubmit={handleSubmit}>
                      <FormLayout>
                        <TextField
                          label="Nombre"
                          type="name"
                          placeholder={edit.name}
                          value={edit.name}
                          autoComplete="off"
                          onChange={(e) =>
                            setEdit({
                              ...edit,
                              name: e,
                            })
                          }
                        />
                        <TextField
                          label="Apellidos"
                          type="text"
                          placeholder={edit.surname}
                          value={edit.surname}
                          autoComplete="off"
                          onChange={(e) =>
                            setEdit({
                              ...edit,
                              surname: e,
                            })
                          }
                        />
                        <TextField
                          label="Email"
                          type="email"
                          placeholder={edit.email}
                          value={edit.email}
                          autoComplete="off"
                          onChange={(e) =>
                            setEdit({
                              ...edit,
                              email: e,
                            })
                          }
                        />
                        <TextField
                          label="Teléfono"
                          type="tel"
                          placeholder={edit.phone}
                          value={edit.phone}
                          autoComplete="off"
                          onChange={(e) =>
                            setEdit({
                              ...edit,
                              phone: e,
                            })
                          }
                        />
                      </FormLayout>
                    </Form>
                  </LegacyCard.Section>
                </LegacyCard>
              </Layout.AnnotatedSection>
              <Layout.AnnotatedSection
                title="Rol de usuario"
                description="El rol de usuario determina los permisos que tiene el usuario para acceder a las diferentes secciones de la aplicación"
              >
                <LegacyCard
                  primaryFooterAction={{
                    content: 'GUARDAR CAMBIOS',
                    onClick: (e) => handleSubmit(),
                  }}
                >
                  <LegacyCard.Section>
                    <Select
                      label="Rol"
                      options={roles.map((r) => ({ label: r.name, value: r.slug }))}
                      onChange={(v) => setEdit({ ...edit, role: v })}
                      value={edit.role}
                    />
                  </LegacyCard.Section>

                  {edit.role === 'promotor' && (
                    <>
                      <LegacyCard.Section>
                        <Checkbox
                          label="Puede ver valores de ventas"
                          checked={edit.canViewSells}
                          onChange={(e) => setEdit({ ...edit, canViewSells: e })}
                        />
                      </LegacyCard.Section>
                      <LegacyCard.Section>
                        <Multiselector
                          title="Depósitos con permisos de trabajo"
                          deposits={operationDeposits}
                          selectedOptions={user.operationDeposits?.map((d) => d.id)}
                          onChange={(selected) => handleChangeDeposits(selected, 'operationDeposits')}
                        />
                      </LegacyCard.Section>

                      <LegacyCard.Section>
                        <Multiselector
                          title="Depósitos válidos para recibir transferencias"
                          deposits={transferDeposits}
                          selectedOptions={user.transferDeposits?.map((d) => d.id)}
                          onChange={(selected) => handleChangeDeposits(selected, 'transferDeposits')}
                        />
                      </LegacyCard.Section>
                    </>
                  )}
                </LegacyCard>
              </Layout.AnnotatedSection>
              <Layout.AnnotatedSection
                id="editUser"
                title="Modificar contraseña"
                description="Introduzca la nueva contraseña dos veces para confirmarla"
              >
                <LegacyCard
                  primaryFooterAction={{
                    content: 'CAMBIAR CONTRASEÑA',
                    onClick: (e) => handleSubmit(),
                    disabled: !pwconfirm,
                  }}
                >
                  <LegacyCard.Section>
                    <Form onSubmit={handleSubmit}>
                      <FormLayout>
                        <TextField
                          label="Contraseña"
                          type="password"
                          placeholder="Cambiar Contraseña"
                          value={edit.password}
                          autoComplete="off"
                          onChange={(e) => {
                            setEdit({
                              ...edit,
                              password: e,
                            });
                            setPwconfirm(e !== '' && e === edit.password);
                          }}
                        />
                        <TextField
                          label="Repetir Contraseña"
                          type="password"
                          placeholder="Repetir Contraseña"
                          value={pwconfirmValue}
                          onChange={(e) => {
                            setPwconfirmValue(e);
                            setPwconfirm(e !== '' && e === edit.password);
                          }}
                          error={pwconfirmValue !== '' && !pwconfirm ? 'Las contraseñas no coinciden' : ''}
                        />
                      </FormLayout>
                    </Form>
                  </LegacyCard.Section>
                </LegacyCard>
              </Layout.AnnotatedSection>
            </Layout>
          </Page>
          <FooterHelp>
            <TextContainer>
              <p>
                <small>
                  Creado el {edit.createdAt && new Date(edit.createdAt).toLocaleString('es-ES')} | Última conexión:{' '}
                  {edit.lastLogin ? new Date(edit.lastLogin).toLocaleString('es-ES') : 'Nunca'} | Última modificación:{' '}
                  {edit.updatedAt && new Date(edit.updatedAt).toLocaleString('es-ES')}{' '}
                </small>
              </p>
            </TextContainer>
          </FooterHelp>
        </>
      )}
    </>
  );
};
export default EditUser;
